import * as LucideIcons from "lucide-react";
import shared from "../../data/js/shared";
import SideRail, { type RailItem } from "../side-rail";

/**
 * Left navigation rail for the admin dash — the same rail the account area uses,
 * fed the admin nav. It replaces the tile grid that used to be the only way in,
 * so moving between dash pages no longer means a round trip through /dash.
 *
 * Rendered once by AllLayout for any /dash route. The nav is long enough that
 * which pages sit near the top is a matter of what each admin actually opens, so
 * the items drag to reorder and the order is remembered in localStorage.
 */

/** localStorage key holding this browser's dash rail order (a list of hrefs). */
export const DASH_RAIL_ORDER_KEY = "dashRailOrder";

/** The dash nav ships Lucide icon names rather than image paths. */
const renderIcon = (icon: string, label: string) => {
  const Icon = (LucideIcons as Record<string, unknown>)[icon] as
    | React.ComponentType<{ size?: number; strokeWidth?: number }>
    | undefined;
  return Icon ? <Icon size={20} strokeWidth={2} /> : <span aria-hidden="true">{label[0]}</span>;
};

/**
 * `pendingPath` is the page a click is loading. The rail marks it at once,
 * rather than holding the old item until the new page arrives.
 */
export default function DashRail({ pathname, pendingPath = null }: { pathname: string; pendingPath?: string | null }) {
  return (
    <SideRail
      pathname={pendingPath ?? pathname}
      items={shared.admin.navButtons as RailItem[]}
      basePath="/dash"
      name="Dash"
      testIdPrefix="dash-rail"
      renderIcon={renderIcon}
      cta={{ label: "Overview", href: "/dash", icon: "LayoutGrid" }}
      reorderKey={DASH_RAIL_ORDER_KEY}
    />
  );
}
